import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext(null);

// Socket.IO disabled — Hostinger shared hosting blocks WebSocket
// Will re-enable when upgraded to VPS
export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount]     = useState(0);

  const markAllRead = () => setUnreadCount(0);
  const clearAll    = () => { setNotifications([]); setUnreadCount(0); };

  return (
    <NotificationContext.Provider value={{ notifications, unreadCount, markAllRead, clearAll }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);